/* eslint-disable */
	module.exports = {"sourcemaps":false,"devspecs":false,"parallelTests":true,"production":false,"reloadless":false,"buildConfig":{"language":"en","locale":"en-US","server":"","login":"","password":"","host":"localhost","port":9000,"https":true,"proxyTargets":["/api","/authentication","/Outlook","/account"],"proxyWSTargets":["/installHub","/objectHub"]}}
/* eslint-enable */
